import CurrencyLogo from 'components/CurrencyLogo'
import Tag from 'components/Tag'
import React from 'react'

import { EntriesStyled, PoolCardStyled } from './styled'
import { SkeletonText } from 'components/Skeleton'
import { useToken } from 'hooks/Tokens'
import { HSPX_ADDRESS } from '@hyperswap/addresses'
import { Currency } from '@uniswap/sdk-core'
import { ReactComponent as LogoWhite } from '../../../assets/logo-full-white.svg'

const IS_DISABLED = true
const HSPXPoolCard = () => {
  const HSPXToken = useToken(HSPX_ADDRESS)

  if (IS_DISABLED) return null

  if (!HSPXToken) return null

  return (
    <PoolCardStyled role="button" to={`/stake/HSPX`} disabled={IS_DISABLED}>
      <div className="poolCard__tag">
        {IS_DISABLED ? <Tag variant={1}>Inactive</Tag> : <Tag variant={2}>Active</Tag>}
      </div>

      <div className="poolCard__header">
        <CurrencyLogo currency={HSPXToken as Currency} size={'42px'} />
        <h2>Stake SWAP</h2>
      </div>
      <div className="poolCard__subheader">
        <LogoWhite />
        <span>Hyperswap Revenue Sharing</span>
      </div>
      <EntriesStyled>
        <span style={{ fontWeight: 500, fontSize: '14px' }}>APR</span>
        <span style={{ fontWeight: 500, fontSize: '14px' }}>TVL</span>
        <span style={{ height: '16px' }}>
          <SkeletonText width="50%" height="100%" />
        </span>
        <span style={{ height: '16px' }}>
          <SkeletonText width="80%" height="100%" />
        </span>
      </EntriesStyled>
    </PoolCardStyled>
  )
}
export default HSPXPoolCard
